import { useEffect, useState } from 'react';
import gsap from 'gsap';

export const useLoaderAnimation = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress === 100) {
      const t1 = gsap.timeline();
      t1.to(".loaderOverlay", {
        opacity: 0,
        duration: 0.5,
        delay: 0.5,
        onComplete: function () {
          gsap.set(".loaderOverlay", { display: "none" });
          gsap.set(".home", { display: "block" });
        },
      });
      t1.to(
        ".circle1",
        {
          left: "0%",
          top: "50%",
          duration: 1,
          ease: "power1.inOut",
        },
        1
      );
      t1.to(
        ".circle2",
        {
          left: "80%",
          top: "2%",
          duration: 1,
          ease: "power1.inOut",
        },
        1
      );
      t1.to(
        ".home",
        {
          opacity: 1,
          duration: 1,
          delay: 1,
        },
        1
      );
    }
  }, [progress]);

  return progress;
};
